<template>
    <span>
      <slot></slot>
    </span>
</template>

<script>
import axios from "axios";
import SecureLS from "secure-ls";

export default {
  name: "EmpresaContainer",
  data() {
    return {
      empresaExiste: false,
      dias: []
    }
  },
  mounted() {
    this.isLoading = true;
    if (this.$store.state.empresa_url == this.$router.currentRoute.params.empresa) {
      if (this.$store.state.produtos.length > 0) {
        this.empresaExiste = true;
      } else {
        this.VerificarEmpresa();
      }
    } else {
      this.VerificarEmpresa();
    }
  },
  methods: {
    async VerificarEmpresa() {
      this.$store.commit('empresaUrl', this.$router.currentRoute.params.empresa);
      await axios.get(this.$store.state.apiUrl + 'empresa/' + this.$store.state.empresa_url).then(res => {
        if (res.data) {
          this.$store.commit('empresa', res.data);
          this.$store.state.empresa.horarios.filter(number => {
            this.dias.push(number.dia)
          });
          this.$store.commit('dias', this.dias);
          this.empresaExiste = true;
        }
      }).catch(error => {
      });

      if (this.empresaExiste) {
        this.obterProdutos();
        this.$store.commit('empresaVerificada', true);
      } else {
        this.$router.push('nao-localizado')
      }
    },
    sortData(key, data, type) {
      let ordered = {};
      let compareFunction = function (a, b) {
        return data[b][key] - data[a][key];
      };
      if (type === "asc") {
        compareFunction = function (a, b) {
          return data[a][key] - data[b][key];
        }
      }
      Object.keys(data).sort(compareFunction).forEach(function (key) {
        ordered[key] = data[key];
      });
      return ordered;
    },
    obterProdutos() {
      axios.get(this.$store.state.apiUrl + 'grupos/secoes/produtos/empresa/' + this.$store.state.empresa_url).then(res => {
        let grupos = [];
        $.each(res.data.grupos, function (key, value) {
          grupos.push(value);
        });

        if (this.$store.state.empresa.tipo_ordenacao_grupo != "LIVRE") {
          grupos.sort((a, b) => (a.grupo.nome > b.grupo.nome) ? 1 : ((b.grupo.nome > a.grupo.nome) ? -1 : 0));
        } else {
          grupos.sort((a, b) => (a.grupo.posicao > b.grupo.posicao) ? 1 : ((b.grupo.posicao > a.grupo.posicao) ? -1 : 0));
        }

        for (let i = 0; i < grupos.length; i++) {

          let secoes = [];
          $.each(grupos[i].secoes, function (key, value) {
            if (value.detalhes.ativo == "S") {
              secoes.push(value);
            }
          });

          if (this.$store.state.empresa.tipo_ordenacao_secao != "LIVRE") {
            secoes.sort((a, b) => (a.detalhes.nome > b.detalhes.nome) ? 1 : ((b.detalhes.nome > a.detalhes.nome) ? -1 : 0));
          } else {
            secoes.sort((a, b) => (a.detalhes.posicao > b.detalhes.posicao) ? 1 : ((b.detalhes.posicao > a.detalhes.posicao) ? -1 : 0));
          }

          // ordenar itens da seção
          //let secoesNew = secoes;
          secoes.forEach((valueSecao, keySecao) => {
            let itens = [];
            $.each(valueSecao.itens, (keyItem, valueItem) => {
              itens.push(valueItem);
            });
            if (this.$store.state.empresa.tipo_ordenacao_secao != "LIVRE") {
              secoes[keySecao].itens = itens.sort((a, b) => (a.nome > b.nome) ? 1 : ((b.nome > a.nome) ? -1 : 0));
            } else {
              secoes[keySecao].itens = itens.sort((a, b) => (a.posicao > b.posicao) ? 1 : ((b.posicao > a.posicao) ? -1 : 0));
            }
          });
          // fim ordenar itens da secao

          grupos[i].secoes = secoes;
        }

        this.$store.commit('grupos', grupos)
        this.$store.commit('produtosPromocao', res.data.promocoes)

        if (JSON.stringify(res.data.promocoes) != "[]") {
          this.$store.commit('produtosPromocaoBool', true)
        }

        this.$store.commit('grupoPromocional', res.data.grupo_promocional)
        var ls = new SecureLS();
        ls.set('gruposSecoesPromocoes', res.data);
      }).catch(error => {

      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Widgets/EmpresaContainer.vue